import {
  TableContainer,
  Table,
  TableRow,
  TableHead,
  TableBody,
} from "@mui/material";
import { StyledTableCell } from "../../../ui-components/StyledTables";
import { ProfileRowPlans } from "./ProfileRowPlan";

import { useSuperAdminPlans } from "../../../context/SuperAdmin/PlanContext";
import { useEffect } from "react";

const PlansTable = () => {
  const { planes, searchText } = useSuperAdminPlans();

  // Filtro de usuarios por búsqueda
  const normalizedSearch = searchText.toLowerCase().trim();
  const filteredPlans = planes.filter((plan) => {
    return plan.nombre.toLowerCase().includes(normalizedSearch);
  });

  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            <StyledTableCell>N°</StyledTableCell>
            <StyledTableCell>Nombre</StyledTableCell>
            <StyledTableCell>Tipo</StyledTableCell>
            <StyledTableCell>Precio</StyledTableCell>
            <StyledTableCell>Duración</StyledTableCell>
            <StyledTableCell>Créditos / mes</StyledTableCell>
            <StyledTableCell>Créditos tot.</StyledTableCell>
            <StyledTableCell>Usuarios Máx.</StyledTableCell>
            <StyledTableCell>Estado</StyledTableCell>
            <StyledTableCell>Acciones</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredPlans.length > 0 ? (
            filteredPlans.map((plan, index) => (
              <ProfileRowPlans key={plan.id_plan} plan={plan} i={index + 1} />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PlansTable;
